<template>
    <div id="contacts" v-if="hasFieldToDisplay()">
        <div class="tabulation-title">
            <h5>
                <v-icon class="blue--text text--darken-2">label</v-icon> Moyens de communication
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <div v-for="contact in contacts" v-if="hasField(contact.name)" class="type-com mb-5">
                <div class="tabulation-title mb-5">
                    <h5 style="font-size: 15px" class="d-flex">
                        <v-icon>{{ getContactIcon(contact.name) }}</v-icon>
                        <div class="mt-auto mb-auto ml-2">{{ contact.label }}</div>
                    </h5>
                </div>

                <div>
                    <div v-for="(com, index) in provider.communications" class="mb-4"
                        v-if="com.type.name === contact.name">
                        <div class="d-flex">
                            <v-text-field v-model="com.value" :placeholder="getPlaceholder(com)"
                                :class="{'input-error': checkFormat(com) !== ''}" outlined>
                            </v-text-field>
                            <v-icon color="red" class="ml-2 mt-auto mb-auto" large @click="deleteCom(com, index)">delete
                            </v-icon>
                        </div>
                        <div class="txt-error mt-1">
                            {{ checkFormat(com) }}
                        </div>
                    </div>

                    <div v-if="getSuggestionByTypeName(contact.name)">
                        <div class="suggestion-container" style="width: 100% !important; margin-bottom: 30px">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <b>Suggestion proposée - {{ contact.label }}</b>
                                </div>

                                <div class="d-flex mb-auto ml-md-0 ml-5 mt-md-auto mt-3">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn small color="success" class="mr-3" icon v-on="on" dark
                                                @click="addSuggestion(contact.name)">
                                                <v-icon>check</v-icon>
                                            </v-btn>
                                        </template>
                                        <div>Accepter</div>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" small dark icon color="error"
                                                @click="removeSuggestion(contact.name)">
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                        </template>
                                        <div>Refuser</div>
                                    </v-tooltip>
                                </div>
                            </div>

                            <div class="mt-3">
                                <div style="color: gray">
                                    <i>Information présente sur {{
                                    getLowerCaseSourceName(getSuggestionByTypeName(contact.name).source.type) }}</i>
                                </div>

                                <v-text-field
                                    v-if="contact.name === 'PHONE' || contact.name === 'FAC' || contact.name === 'EMAIL'"
                                    :value="getSuggestionByTypeName(contact.name).value" outlined disabled>
                                </v-text-field>

                                <v-text-field v-else :value="getSuggestionByTypeName(contact.name).value" outlined
                                    append-icon="open_in_new"
                                    @click:append="openLink(getSuggestionByTypeName(contact.name).value)">
                                </v-text-field>
                            </div>
                        </div>
                    </div>

                    <div class="w-100 mt-5">
                        <v-btn text color="primary" class="text-none" @click="addCom(contact)">
                            <v-icon class="mr-2">add</v-icon> Ajouter {{ getComSuggestionButtonWord(contact) }}
                        </v-btn>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import PhoneNumber from 'awesome-phonenumber'
import * as EmailValidator from 'email-validator'
import { mapGetters, mapMutations, mapState } from "vuex"
import _ from "lodash"

export default {
    name: "Contacts",
    props: ['contacts'],
    data() {
        return {
            urls: ['WEBSITE', 'GOOGLE', 'FACEBOOK', 'TWITTER', 'TRIPADVISOR', 'YELP', 'YOUTUBE', 'INSTAGRAM', 'LINKEDIN', 'TIKTOK']
        }
    },
    methods: {
        ...mapMutations('web_form', [
            'updateProvider'
        ]),
        hasFieldToDisplay() {
            let has = false

            this.contacts.forEach(contact => {
                if (this.hasField(contact.name)) {
                    has = true
                }
            })

            return has
        },
        deleteCom(com, index) {
            let coms = this.getComByCode(com.type.name)

            if (coms.length > 1) {
                this.provider.communications.splice(index, 1)

                this.$forceUpdate()
            } else {
                com.value = null
            }
        },
        getComByCode(code) {
            let coms = collect(this.provider.communications)

            return coms.where('type.name', code).all()
        },
        addCom(contact) {
            let com = {
                value: null,
                type: contact
            }

            this.provider.communications.push(com)

            this.$forceUpdate()
        },
        checkFormat(com) {
            let result = ''

            if (com.type.name === 'PHONE' && com.value !== null) {
                let phoneFr = new PhoneNumber(com.value, 'FR')
                let phoneNc = new PhoneNumber(com.value, 'NC')
                let phoneCAN = new PhoneNumber(com.value, 'CA')

                result = (phoneFr.isValid() || phoneNc.isValid() || phoneCAN.isValid()) ?
                  '' : 'Le format du téléphone n\'est pas correct'
            }

            if (com.type.name === 'EMAIL' && com.value !== null) {
                let isValidEmail = EmailValidator.validate(com.value)
                result = isValidEmail ? '' : 'Le format de l\'email n\'est pas correct'
            }

            return result
        },
        getPlaceholder(com) {
            return this.urls.includes(com.type.name) ? 'HTTPS' : ''
        },
        getSuggestionByTypeName(name) {
            let exist = this.suggestedCommunications.find(com => com.type.name === name)

            return exist !== undefined ? exist : null
        },
        removeSuggestion(name) {
            this.suggestedCommunications.forEach((suggestion, index) => {
                if (suggestion.type.name === name) {
                    this.suggestedCommunications.splice(index, 1)
                }
            })
        },
        addSuggestion(name) {
            this.suggestedCommunications.forEach((suggestion, index) => {
                if (suggestion.type.name === name) {
                    let coms = this.provider.communications.filter(com => com.type.name === suggestion.type.name)

                    if (coms !== undefined && (coms[0].value === null || coms[0].value === '')) {
                        this.provider.communications.forEach(com => {
                            if (com.type.name === suggestion.type.name) {
                                com.value = suggestion.value
                            }
                        })
                    } else {
                        let com = {
                            value: suggestion.value,
                            type: suggestion.type
                        }

                        this.provider.communications.push(com)
                    }

                    this.suggestedCommunications.splice(index, 1)
                }
            })
        },
        getContactIcon(name) {
            let icon = null

            switch (name) {
                case 'EMAIL':
                    icon = 'email'
                    break
                case 'PHONE':
                case 'FAX':
                    icon = 'phone'
                    break
                default:
                    icon = 'language'
            }

            return icon
        },
        getComSuggestionButtonWord(contact) {
            let label = null

            switch (contact.name) {
                case 'EMAIL':
                    label = ' une adresse email'
                    break
                case 'PHONE':
                    label = ' un téléphone'
                    break
                case 'FAX':
                    label = ' un fax'
                    break
                default:
                    label = ' un lien ' + contact.label
            }

            return label
        },
        openLink(link) {
            window.open(link, '_blank')
        },
        getLowerCaseSourceName(name) {
            return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'disabled', 'suggestedCommunications']),
        ...mapGetters('web_form', ['hasField'])
    },
    watch: {
        provider: {
            handler: _.debounce(function () {
                this.updateProvider(this.provider)
            }, 200),
            deep: true
        }
    },
    created() {
        this.contacts.forEach(contact => {
            let hasEntry = false

            this.provider.communications.forEach(com => {
                if (com.type.name === contact.name) {
                    hasEntry = true
                }
            })

            if (!hasEntry) {
                this.addCom(contact)
            }
        })
    }
}
</script>
